import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import QueryParams from '../../services/QueryParams';
import FormData from '../../services/FormData';
import Http from '../../services/Http';
import Storage from '../../services/Storage';
import Logo from '../../logos/logo-white.png';
import { Link, useHistory } from 'react-router-dom';
import { useCallback, useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import IEVersion from '../../services/IEVersion';
import Copyright from '../../common/Copyright';
import PrivacyPolicy from '../../common/PrivacyPolicy';
import ReCaptcha from '../../common/ReCaptcha';

const Login = (props: any) => {
    const [http] = useState(new Http());
    const [storage] = useState(new Storage());
    const [queryParams] = useState(new QueryParams());
    const [signingIn, setSigningIn] = useState(false);
    const [token, setToken] = useState(storage.token());
    const [reCaptchaToken, setReCaptchaToken] = useState("");
    const [reCaptchaTimestamp, setReCaptchaTimestamp] = useState(0);
    const history = useHistory();

    const reCaptchaReload = () => {
        setReCaptchaTimestamp(new Date().getTime());
    };

    const redirect = useCallback((loginResp?: any) => {
        console.log(loginResp);
        if (!loginResp || (loginResp.company && loginResp.company.name)) {
            if (queryParams.get("returnTo")) {
                window.location.href = queryParams.get("returnTo");
            } else {
                window.location.href = `${process.env.REACT_APP_IEC_ID_URL}`;
            }
        } else {
            history.push({
                pathname: "/sign-up/complete",
                search: queryParams.search()
            });
        }
    }, [history, queryParams]);

    const login = useCallback(async (e: any) => {
        e.preventDefault();
        let login: { status: number; data: { token: string | undefined; email: string | undefined; message: any; }; };
        setSigningIn(true);
        try {
            login = await http.post('authenticate', new FormData('login_form').toJson());
            if (login.status < 400) {
                toast.success("Login successful");
                storage.token(login.data.token);
                storage.email(login.data.email);
                setTimeout(function () {
                    redirect(login.data);
                }, 500);
            } else {
                reCaptchaReload();
                // eslint-disable-next-line no-mixed-operators
                toast.error(login && login.data && login.data.message || "Something went wrong.");
            }
        } catch (e: any) {
            reCaptchaReload();
            toast.error(e && e.response && e.response.data && e.response.data.message ? e.response.data.message : ((e && e.message) || "Something went wrong."));
        }
        setSigningIn(false);
    }, [http, redirect, storage]);

    useEffect(() => {
        window.addEventListener("storage", function (e: any) {
            if (storage.token()) {
                setToken(storage.token());
            }
        });
    }, [storage]);

    const handleError = useCallback((resp: any) => {
        switch (resp.status) {
            case 401:
                storage.remove("sso_token");
                setToken("");
                break;

            case 403:
                redirect();
                break;

            default:
                toast.info(resp.data.message);
                break;
        }
    }, [redirect, storage]);

    useEffect(() => {
        if (token) {
            http.secureGet(`mock`)
                .then((resp: any) => {
                    if (resp.status === 200) {
                        console.log("mock successful", resp.data.data);
                        setTimeout(() => {
                            redirect(resp.data.data);
                        }, 40);
                    } else {
                        handleError(resp);
                    }
                })
                .catch((error: any) => {
                    if (error.response) {
                        handleError(error.response);
                    } else {
                        toast.error("Something went wrong!");
                    }
                });
        }
    }, [handleError, http, redirect, token]);

    return (
        <div className="global-container bg-gradient">
            <ReCaptcha action="LOGIN" reCaptchaTimestamp={reCaptchaTimestamp} onToken={setReCaptchaToken} />
            <div id="tweak">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 d-flex">
                            <div className="mt-auto mb-auto text-center text-md-left">
                                <img src={Logo} style={{ pointerEvents: 'none' }} width="240" alt="" />
                                <h4 className="text-white mt-4 d-inline-block" style={{ lineHeight: 1.5 }}>
                                    {props.isOnScreen ?
                                        <span>Your session was expired! Please sign in again to continue.</span>
                                        :
                                        <span>Please sign in to continue. One account for everything at insurEco.</span>}
                                </h4>
                                {!props.isOnScreen && <Link to="/learn-more" target="_blank" className="btn btn-light mt-3 d-none d-md-inline-block" rel="noreferrer">Learn more</Link>}
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="card login-form mt-4 ml-auto mr-auto">
                                <div className="card-body">
                                    <div className="card-text">
                                        <form name="login_form" onSubmit={login} id="login_form">
                                            <input type="hidden" name="reCaptcha" value={reCaptchaToken} />
                                            <div className="form-group">
                                                {IEVersion() < 10 ? <label>Email address</label> : <span></span>}
                                                {
                                                    props.isOnScreen ?
                                                        <span>
                                                            Enter password for <strong>{storage.email()}</strong>
                                                            {/* <a onClick={switchAccount}></a> */}
                                                            <input type="hidden" id="username" name="username" value={storage.email() || ''} />
                                                        </span>
                                                        :
                                                        <input type="email" placeholder="Email address" className="form-control form-control-lg" id="username" name="username" />
                                                }
                                            </div>
                                            <div className="form-group">
                                                {IEVersion() < 10 && !props.isOnScreen ? <label>Password</label> : <span></span>}
                                                <input type="password" placeholder="Password" className="form-control form-control-lg" id="password" name="password" />
                                            </div>
                                            <button type="submit" disabled={signingIn} className="btn btn-secondary btn-lg btn-block">
                                                {signingIn ? <span> Signing In&hellip;</span> : "Sign In"}
                                                {signingIn ? <span>
                                                    &nbsp;&nbsp;
                                                    <FontAwesomeIcon icon={faSpinner} className="fa-spin" />
                                                </span> : <span></span>}
                                            </button>
                                            <div className="text-center mt-3">
                                                <Link className="text-secondary" to={{
                                                    pathname: "forgot-password",
                                                    search: queryParams.search()
                                                }}>Forgot password?</Link>
                                            </div>
                                            <div className="sign-up text-center">
                                                <Link to={{
                                                    pathname: "sign-up",
                                                    search: queryParams.search()
                                                }} className="btn btn-success btn-lg">Create New Account</Link>
                                            </div>
                                            <PrivacyPolicy />
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Copyright />
        </div>
    );
}

export default Login;